import RBAC from './RBACTable';

export default RBAC;
